import React from 'react';
import { Container, Typography, Box, Grid, Paper, List, ListItem, ListItemText, Chip } from '@mui/material';
import { useParams } from 'react-router-dom';
import services from '../data/servicesData';
import ImageLightbox from './ImageLightbox';

export default function ServiceDetail() {
  const { slug } = useParams();
  const item = services.find(s => s.slug === slug) || null;

  React.useEffect(() => {
    if (item) document.title = `${item.title} — NehaInfoTech`;
    return () => { document.title = 'NehaInfoTech'; };
  }, [item]);

  const [open, setOpen] = React.useState(false);

  if (!item) {
    return (
      <Container sx={{ py: 6 }}>
        <Typography variant="h4">Service not found</Typography>
      </Container>
    );
  }

  return (
    <Container sx={{ py: 6 }}>
      <Typography variant="h4" gutterBottom>{item.title}</Typography>
      <Typography color="text.secondary" sx={{ mb: 2 }}>{item.short}</Typography>
      <Grid container spacing={4}>
        <Grid item xs={12} md={8}>
          <Box>
            <Box component="img" src={item.image} onClick={() => setOpen(true)} sx={{ width: '100%', height: 420, objectFit: 'cover', borderRadius: 2, cursor: 'pointer' }} />
            <ImageLightbox open={open} onClose={() => setOpen(false)} src={item.image} alt={item.title} caption={item.short} />
          </Box>
          <Typography sx={{ mt: 3 }}>{item.description}</Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Paper sx={{ p: 2 }} elevation={2}>
            <Typography variant="h6">What we deliver</Typography>
            <List>
              {item.features.map(f => (
                <ListItem key={f}><ListItemText primary={f} /></ListItem>
              ))}
            </List>
            <Typography variant="subtitle2" sx={{ mt: 1 }}>Tech & tools</Typography>
            <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mt: 1 }}>
              {item.tech.map(t => <Chip key={t} label={t} size="small" />)}
            </Box>
            <Typography variant="subtitle2" sx={{ mt: 2 }}>Approach</Typography>
            <Typography variant="body2" sx={{ mt: 1 }}>{item.approach}</Typography>
            <Typography variant="caption" display="block" sx={{ mt: 2 }}>Typical duration: {item.typicalDuration} • Team size: {item.teamSize}</Typography>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
}
